import { common } from '@featit/shared/i18n/messages/en/common';

/**
 * What a control says when its access read failed, timed out, or answered in a shape it cannot use.
 * Its tooltip, its accessible description and its touch hint (`RefusedTouchHint`) all read it from
 * the control's `title`; pressing the control — click, tap, Enter or Space — is the Retry. These
 * constants are the English (I-1925); a gate says the line in the page's language, from the catalogue.
 */
export const ACCESS_UNREAD_REASON = common.accessUnread;
/** The same, for a read that has no way to ask again from the control: the page has to be read again. */
export const ACCESS_UNREAD_NO_RETRY_REASON = common.accessUnreadNoRetry;

/** What a control says while its read is asked again after it failed (I-1708, KD-17a). */
export const CHECKING_ACCESS_AGAIN = common.checkingAccessAgain;
